/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function DinersLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <DinersLogo.Outline {...props} />
  ) : (
    <DinersLogo.Solid {...props} />
  );
}

DinersLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

DinersLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <rect width="70" height="48" rx="4" fill="#0079BE" />
        <path
          d="M38.09 38.9997C45.8851 39.0373 53 32.5841 53 24.7338C53 16.1497 45.8851 10.2155 38.09 10.2188H31.3813C23.4933 10.2155 17 16.1513 17 24.7338C17 32.5857 23.4933 39.0373 31.3813 38.9997H38.09Z"
          fill="#0079BE"
        />
        <path
          d="M31.4128 11.4082C24.2042 11.4106 18.3637 17.3063 18.3613 24.5831C18.3637 31.859 24.2042 37.7547 31.4128 37.7571C38.6223 37.7547 44.4652 31.859 44.466 24.5831C44.4652 17.3063 38.6231 11.4106 31.4128 11.4082ZM23.1404 24.5831C23.1389 22.9006 23.6449 21.2569 24.5925 19.8666C25.54 18.4763 26.8849 17.4043 28.4514 16.7905V32.3749C26.8847 31.7615 25.5397 30.6897 24.5921 29.2995C23.6446 27.9093 23.1386 26.2655 23.1404 24.5831ZM34.3735 32.3781V16.7897C35.9412 17.4026 37.2872 18.4746 38.2354 19.8653C39.1837 21.256 39.6898 22.9007 39.6877 24.5839C39.6895 26.267 39.1832 27.9115 38.235 29.3022C37.2869 30.6928 35.941 31.7649 34.3735 32.3781Z"
          fill="white"
        />
        <path
          d="M38.09 38.9997C45.8851 39.0373 53 32.5841 53 24.7338C53 16.1497 45.8851 10.2155 38.09 10.2188H31.3813C23.4933 10.2155 17 16.1513 17 24.7338C17 32.5857 23.4933 39.0373 31.3813 38.9997H38.09Z"
          fill="white"
        />
        <path
          d="M31.4128 11.4082C24.2042 11.4106 18.3637 17.3063 18.3613 24.5831C18.3637 31.859 24.2042 37.7547 31.4128 37.7571C38.6223 37.7547 44.4652 31.859 44.466 24.5831C44.4652 17.3063 38.6231 11.4106 31.4128 11.4082ZM23.1404 24.5831C23.1389 22.9006 23.6449 21.2569 24.5925 19.8666C25.54 18.4763 26.8849 17.4043 28.4514 16.7905V32.3749C26.8847 31.7615 25.5397 30.6897 24.5921 29.2995C23.6446 27.9093 23.1386 26.2655 23.1404 24.5831ZM34.3735 32.3781V16.7897C35.9412 17.4026 37.2872 18.4746 38.2354 19.8653C39.1837 21.256 39.6898 22.9007 39.6877 24.5839C39.6895 26.267 39.1832 27.9115 38.235 29.3022C37.2869 30.6928 35.941 31.7649 34.3735 32.3781Z"
          fill="#0079BE"
        />
      </>
    ),
  });

  return <Icon viewBox="0 0 70 48" {...validateKeys(props)} />;
};
